export default __webpack_public_path__ + "static/media/image.rav-entertainment-pvt-ltd.c49da664.png";